import React, { useEffect } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { User, Settings, Lock } from "react-feather";

import QuckSellForm from "./quckSellForm";
import { queryString } from "./../../utils/queryString";
import EditProfile from "./editProfile";
import ChangePassword from "./changePassword";
import OtherSettingForm from "./otherSetting";
import LiveDropsBets from "./liveDropsBets";
// import HideRollChance from "./HideRollChance";
// import HideTryForFree from "./hideTryForFree";

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import TwoFaSetting from "./twoFaSetting";
// import PaymentOption from "./paymentOption";
// import ShippingManagement from "../shippingManagement";
const TabsetProfile = ({
  userData,
  handleEdit,
  edit,
  handleChange,
  handleUpdate,
}) => {
  const { tab } = queryString();
  const history = useHistory();
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || [];

  // const [tabVisibility,setTabVisibility] = useState(false)
  useEffect(() => {
    if (role?.length > 0) {
      let chekPer = role?.some((r) =>
        [
          "suUsers",
          "superAdmin",
          `write${capitalizeFirstLetter(tab)}`,
          `read${capitalizeFirstLetter(tab)}`,
          ...(tab === "liveDropsBets" ? ["readSetting", "writeSetting"] : []),
        ].includes(r),
      );

      if (!chekPer && tab === "profile") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "changePassword") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "quickSellPercentage") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "otherSettings") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "hideRolChance") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "hideTryForFree") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "paymentOptions") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "security") {
        history.push("/dashboard");
      } else if (!chekPer && tab === "liveDropsBets") {
        history.push("/dashboard");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Tabs>
        <TabList className="nav nav-tabs tab-coupon">
          {role?.some((r) =>
            [
              "suUsers",
              "superAdmin",
              "readProfile",
              "writeProfile",
              "readSetting",
              "writeSetting",
            ].includes(r),
          ) &&
            tab === "profile" && (
              <Tab className="nav-link">
                <User className="mr-2" />
                Profile
              </Tab>
            )}

          {role?.some((r) =>
            [
              "suUsers",
              "superAdmin",
              "readChangePassword",
              "writeChangePassword",
              "readSetting",
              "writeSetting",
            ].includes(r),
          ) &&
            tab === "changePassword" && (
              <Tab className="nav-link">
                <Settings className="mr-2" />
                Change Password
              </Tab>
            )}

          {role?.some((r) => ["suUsers", "superAdmin"].includes(r)) &&
            tab === "security" && (
              <Tab className="nav-link">
                <Lock className="mr-2" />
                Security
              </Tab>
            )}

          {tab === "preferences" && (
            <Tab className="nav-link">
              <Settings className="mr-2" />
              Percentage Setting
            </Tab>
          )}

          {tab === "liveDropsBets" && (
            <Tab className="nav-link">
              <Settings className="mr-2" />
              Live Drops
            </Tab>
          )}
        </TabList>

        {role?.some((r) =>
          [
            "suUsers",
            "superAdmin",
            "readProfile",
            "writeProfile",
            "readSetting",
          ].includes(r),
        ) &&
          tab === "profile" && (
            <TabPanel>
              <EditProfile
                handleUpdate={handleUpdate}
                handleEdit={handleEdit}
              />
            </TabPanel>
          )}

        {role?.some((r) =>
          [
            "suUsers",
            "superAdmin",
            "readChangePassword",
            "writeChangePassword",
            "readSetting",
            "writeSetting",
          ].includes(r),
        ) &&
          tab === "changePassword" && (
            <TabPanel>
              <ChangePassword />
            </TabPanel>
          )}
        {role?.some((r) => ["suUsers", "superAdmin"].includes(r)) &&
          tab === "security" && (
            <TabPanel>
              <h5 className="f-w-600 f-16">Two Factor Authentication</h5>
              <TwoFaSetting />
            </TabPanel>
          )}


        {role?.some((r) =>
          [
            "suUsers",
            "superAdmin",
            "readQuickSellPercentage",
            "writeQuickSellPercentage",
            "readSetting",
            "writeSetting",
          ].includes(r),
        ) &&
          tab === "preferences" && (
            <TabPanel>
              <div className="account-setting">
                <h5 className="f-w-600 f-16">
                  Exchange, Sell Item & Upgrader Percentage
                </h5>
                <QuckSellForm />
              </div>
            </TabPanel>
          )}
        {tab === "preferences" && (
          <TabPanel>
            <div className="account-setting">
              <h5 className="f-w-600 f-16">Percentage Settings</h5>
              <OtherSettingForm />
            </div>
          </TabPanel>
        )}

        {tab === "liveDropsBets" && (
          <TabPanel>
            <LiveDropsBets />
          </TabPanel>
        )}
      </Tabs>
    </div>
  );
};

export default TabsetProfile;
